import { ref, computed } from 'vue'

export default function useMultiselectTranslations(locale) {
  // Définir les traductions par défaut
  const defaultTranslations = {
    selectLabel: 'Sélectionner',
    selectGroupLabel: 'Sélectionner un groupe',
    deselectLabel: 'Désélectionner',
    deselectAllLabel: 'Tout désélectionner',
    searchPlaceholder: 'Rechercher...',
    searchNoResults: 'Aucun résultat trouvé',
    tagRemoveLabel: 'Supprimer',
    tagError: "Erreur lors de l'ajout de l'élément",
    loading: 'Chargement...',
    noOptions: 'Aucune option disponible'
  }
  const enTranslations = {
    selectLabel: 'Select',
    selectGroupLabel: 'Select a group',
    deselectLabel: 'Deselect',
    deselectAllLabel: 'Deselect all',
    searchPlaceholder: 'Search...',
    searchNoResults: 'No results found',
    tagRemoveLabel: 'Remove',
    tagError: 'Error adding element',
    loading: 'Loading...',
    noOptions: 'No options available'
  }


  // Créer une référence mutable pour les traductions
  const translations = ref(defaultTranslations)
  if (locale === 'en') {
    translations.value = enTranslations
  }

  // Méthode pour mettre à jour les traductions
  function updateTranslations(newTranslations) {
    translations.value = { ...defaultTranslations, ...newTranslations }
  }

  // Obtenir une traduction spécifique
  function getTranslation(key) {
    return translations.value[key]
  }

  // Obtenir toutes les traductions
  const allTranslations = computed(() => translations.value)

  // Retourner les méthodes et les données nécessaires
  return {
    updateTranslations,
    getTranslation,
    allTranslations
  }
}
